// MUI
import { Box, Fade } from "@mui/material";

// Components
import { LoadingSpinner } from "@/Layouts/components/LoadingSpinner";

interface ICitDataTableTitleProps {
	source: string;
	isFetching: boolean;
}

export function CitDataTableTitle({ isFetching, source }: Readonly<ICitDataTableTitleProps>) {
	return (
		<Box mt={-5}>
			<Fade timeout={400} in={isFetching} unmountOnExit>
				<div>
					<LoadingSpinner label={`${source} are still loading...`} className="items-center" />
				</div>
			</Fade>
		</Box>
	);
}
